import { ProSidebarProvider } from "react-pro-sidebar";
import HomeLayout from "../layout/homeLayout";
import About from "../pages/about/about";
import Sell from "../pages/buy/buy";
import Contacts from "../pages/contacts/contacts";
import Home from "../pages/home/home";
import Buy from "../pages/sell/sell";
import Services from "../pages/services/services";
import ServicesOrders from "../pages/services/services_orders";
import Price from "../pages/statistics/price";
import ProtectedRoute from "../utils/protectedRoute";
import { Route, Navigate } from "react-router-dom";
import ProfileLayout from "../layout/ProfileLayout";
import Favorites from "../pages/me/favorites";
import CropsInputs from "../pages/me/components/CropsInputs";
import ServicesInputs from "../pages/me/components/ServicesInputs";
import InputsInputs from "../pages/me/components/InputsInputs";
import AuctionsInputs from "../pages/me/components/AuctionsInputs";
import Inputs from "../pages/me/inputs";
import Auction from "../pages/auction/auction";
import SingleAuction from "../pages/auction/component/single_auction";
import InputsOffers from "../pages/inputs/inputs_offers";
import InputsOrders from "../pages/inputs/inputs_orders";
import MahsoolGuide from "../pages/mahsoolGuide/mahsool_guide";
import WeatherPage from "../pages/weather/weatherPage";
import Signin from "../pages/signin";
import Signup from "../pages/signup";
import Addform from "../components/addform";
import AddAuction from "../pages/auction/component/add_auction";
import AddInput from "../pages/inputs/components/add-input";
import AddService from "../pages/services/add_service";
import ChangePassword from "../pages/me/components/ChangePassword";
import ChangePhonenumber from "../pages/me/components/ChangePhonenumber";
import UpdateProfileInfo from "../pages/me/components/UpdateProfileInfo";
import Stats from "../pages/statistics/Stats";
import Erorr from "../components/Erorr";
import StatsLayout from "../layout/StatsLayout";
import Blogs from "../pages/blogs/Blogs";
import SingleBlog from "../pages/blogs/SingleBlog";
import PrivacyPolicy from "../pages/privacypolicy/PrivacyPolicy";
import TermsOfService from "../pages/terms/TermsOfService";
import SingleAlert from "../pages/weather/singleAlert";
import MahsoolNegotiation from "../pages/negoiation/negotiation";
import InvoicePage from "../pages/invoice/invoice";
import Negotiations from "../pages/me/messages";
import Invoices from "../pages/me/invoices";
import MyOrders from "../pages/me/myOrders";
import OrderDetails from "../pages/me/single-order";
import MySales from "../pages/me/mySales";
import Notifications from "../pages/me/notifications";
import InKindContribution from "../pages/me/InKindContribution";
import OfferDetailsPage from "../pages/sell/offer-details";
import Me from "../pages/me/me";
import InputDetailsPage from "../pages/inputs/InputDetailsPage";
import UnderConstruction from "../pages/construction/construction";
import Gallery from "../pages/gallery/Gallery";
import InKindLanding from "../pages/in-kind/InKindLanding";
import DonateCrop from "../pages/in-kind/DonateCrop";
import RequestCrop from "../pages/in-kind/RequestCrop";
import RequestService from "../pages/in-kind/RequestService";
import DonateService from "../pages/in-kind/DonateService";
import RequestInput from "../pages/in-kind/RequestInput";
import DonateInput from "../pages/in-kind/DonateInput";
import InKindOrderDetails from "../pages/me/single-in-kind-order";
import NegotiationsList from "../pages/me/negotiations";
import NegotiationDetails from "../pages/me/negotiations/[id]";

export const router = (isAuth) => {

  const isUnderConstruction = process.env.REACT_APP_UNDER_CONSTRUCTION === 'true';
  console.log("Under Construction:", isUnderConstruction);
  if (isUnderConstruction) {
    return (
      <>
        <Route path="/" element={<UnderConstruction />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </>
    );
  }

  return (
    <>
      <Route path="/" element={<Home></Home>}></Route>
      <Route path="/home" element={<HomeLayout />}>
        <Route path="cropsOffers" element={<Buy />} />
        <Route path="cropsBuy" element={<Sell />} />
        <Route path="offers/:id" element={<OfferDetailsPage />} />

        <Route path="prices" element={<StatsLayout />}>
          <Route index element={<Navigate to="updates" replace />} />
          <Route index path="updates" element={<Price />} />
          <Route path="statistics" element={<Stats />} />
        </Route>
        <Route path="contacts" element={<Contacts />} />
        <Route path="services" element={<Services />} />
        <Route path="servicesOrders" element={<ServicesOrders />} />
        <Route path="about" element={<About />} />
        <Route path="blogs" element={<Blogs />} />
        <Route path="blogs/:id" element={<SingleBlog />} />
        <Route path="alerts/:id" element={<SingleAlert />} />
        <Route path="gallery" element={<Gallery />} />
        {/* New Negotiation Chat Route */}
        <Route path="negotiation/:negotiationId" element={<MahsoolNegotiation />} />
        {/* <Route path="negotiations" element={<NegotiationsList />} /> */}
        <Route path="negotiations/:id" element={<NegotiationDetails />} />

        <Route path="invoice/:id" element={<InvoicePage />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<TermsOfService />} />
        <Route path="in-kind" element={<InKindLanding />} />
        <Route path="donate-crop" element={<DonateCrop />} />
        <Route path="request-crop-help" element={<RequestCrop />} />
        <Route path="donate-service" element={<DonateService />} />
        <Route path="request-service-help" element={<RequestService />} />
        <Route path="donate-input" element={<DonateInput />} />
        <Route path="request-input-help" element={<RequestInput />} />
        <Route
          path="profile"
          element={
            <ProtectedRoute isAuth={isAuth}>
              <ProSidebarProvider>
                <ProfileLayout />
              </ProSidebarProvider>
            </ProtectedRoute>
          }
        >
          <Route index element={<Me />} />
          <Route path="me" element={<Me />} />
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="my-sales" element={<MySales />} />
          <Route path="order/:orderId" element={<OrderDetails />} />
          <Route path="in-kind-order/:orderId" element={<InKindOrderDetails />} />
          <Route path="invoices" element={<Invoices />} />
          {/* <Route path="negotiations" element={<Negotiations />} /> */}
          <Route path="negotiations" element={<NegotiationsList />} />
          <Route path="donations" element={<InKindContribution />} />
          {/* Routes for crops contributions */}
          <Route path="crops/my-donations" element={
            <InKindContribution contributionType="donations" category="crops" />
          } />
          <Route path="crops/my-needs" element={
            <InKindContribution contributionType="needs" category="crops" />
          } />

          {/* Routes for services contributions */}
          <Route path="services/my-donations" element={
            <InKindContribution contributionType="donations" category="services" />
          } />
          <Route path="services/my-needs" element={
            <InKindContribution contributionType="needs" category="services" />
          } />
          <Route path="fav" element={<Favorites />} />
          <Route path="crops" element={<CropsInputs />} />
          <Route path="services" element={<ServicesInputs />} />
          <Route path="inputs" element={<InputsInputs />} />
          <Route path="auctions" element={<AuctionsInputs />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="change-phonenumber" element={<ChangePhonenumber />} />
          <Route path="update-info" element={<UpdateProfileInfo />} />


        </Route>
        <Route
          path="profile_favorites"
          element={
            <ProtectedRoute isAuth={isAuth}>
              <Favorites />
            </ProtectedRoute>
          }
        />
        <Route
          path="profile_inputs"
          element={
            <ProtectedRoute isAuth={isAuth}>
              <Inputs />
            </ProtectedRoute>
          }
        />
        <Route path="cropsAuction" element={<Auction />} />
        <Route path="single_auction/:id" element={<SingleAuction />} />

        <Route path="productsOffers" element={<InputsOffers />} />
        <Route path="productsOffers/:id" element={<InputDetailsPage />} />
        <Route path="productsOrders" element={<InputsOrders />} />
        <Route
          path="mahsool-guide"
          element={
            <ProtectedRoute isAuth={isAuth}>
              <MahsoolGuide />
            </ProtectedRoute>
          }
        />
        <Route path="weather" element={<WeatherPage />} />
      </Route>
      <Route path="/signin" element={<Signin></Signin>}></Route>
      <Route path="/signup" element={<Signup></Signup>}></Route>
      <Route
        path="/addform"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <Addform type="sell"></Addform>
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/addformOrder"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <Addform type="buy"></Addform>
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/add_auction"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddAuction />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/addInput"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddInput type="sell" />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/addInputOrder"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddInput type="buy" />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/editInput/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddInput type="sell" isEdit={true} />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/editInputOrder/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddInput type="buy" isEdit={true} />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/editform/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <Addform type="sell" isEdit={true}></Addform>
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/editformOrder/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <Addform type="buy" isEdit={true}></Addform>
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/addserviceOffer"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddService type="supply" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/addserviceOrders"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddService type="demand" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editService/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddService type="supply" isEdit={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editServiceOrder/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <AddService type="demand" isEdit={true} />
          </ProtectedRoute>
        }
      />

      <Route path="*" exact={true} element={<Erorr />} />
    </>
  );
};
